export const headArrContent = [
  {
    text: '',
    styles: { flex: 1 },
  },
  {
    text: 'Name',
    styles: { flex: 5 },
  },
  {
    text: 'Title',
    styles: { flex: 4.5 },
  },
  {
    text: 'Display?',
    styles: { flex: 2, justifyContent: 'center' },
  },
  {
    text: 'LinkedIn URL',
    styles: { flex: 6 },
  },
  {
    text: '',
    styles: { flex: 1 },
  },
];

export const formatFun = (data) => {
  const obj = {
    buyer: {},
    target: {},
  };
  Array.isArray(data) &&
    data.map((item) => {
      if (item) {
        if (item.info.value === 'Key Contacts') {
          obj.buyer.executives = item.buyer;
          obj.target.executives = item.target;
        } else {
          obj.buyer[item.info.value] = item.buyer;
          obj.target[item.info.value] = item.target;
        }
      }
      return item;
    });
  return obj;
};

export const resortFun = (arr = [], oldNum, newNum) => {
  if (oldNum && newNum) {
    [arr[oldNum], arr[newNum]] = [arr[newNum], arr[oldNum]];
  } else {
    const popItem = Array.isArray(arr) && arr.pop();
    arr.unshift(popItem);
  }
  return arr;
};

export const addMarkToKeyName = (obj, mark) => {
  const newObj = {};
  Object.keys(obj).map((item) => {
    newObj[item + mark] = obj[item];
    return item;
  });
  return newObj;
};
export const deleteMarkFromKeyName = (obj, mark) => {
  const newObj = {};
  Object.keys(obj).map((item) => {
    newObj[item.replace(mark, '')] = obj[item];
    return item;
  });
  return newObj;
};
export const deleteAttribute = (obj, mark) => {
  Object.keys(obj).map((item) => {
    if (item.search(mark) !== -1) {
      delete obj[item];
    }
    return item;
  });
  return obj;
};
